// Point the inline <use> element at the emitted sprite URL.
export function applyLogoHref(useElement, spriteUrl) {
  if (!useElement || !spriteUrl) return;
  useElement.setAttribute("href", `${spriteUrl}#logo-mark`);
  useElement.setAttribute("xlink:href", `${spriteUrl}#logo-mark`);
}
